import { fiscatCashBoxDriver } from './fiscatCashBox'
import { fiscatIPalmDriver } from './fiscatIPalm'
import { fiscatNeonPlusDriver } from './fiscatNeonPlus'
import { fiscatA180Driver } from './fiscatA180'
import { fiscatV4Driver } from './fiscatV4'
import { fiscatV5Driver } from './fiscatV5'
import { fiscatV6Driver } from './fiscatV6'
import { fiscatV8Driver } from './fiscatV8'
import { micraNanoDriver } from './micraNano'
import { micraSentoDriver } from './micraSento'
import { micraJotaDriver } from './micraJota'
import { micraMiniDriver } from './micraMini'
import { datecsDriver } from './datecs'
import { sam4sDriver } from './sam4s'
import merge from 'lodash.merge'

const drivers = merge({},
  fiscatCashBoxDriver,
  fiscatIPalmDriver,
  fiscatNeonPlusDriver,
  micraNanoDriver,
  micraSentoDriver,
  micraJotaDriver,
  micraMiniDriver,
  datecsDriver,
  sam4sDriver,
  fiscatA180Driver,
  fiscatV4Driver,
  fiscatV5Driver,
  fiscatV6Driver,
  fiscatV8Driver
)

export {
  drivers
}